export default class FormValidation {
    constructor() {
        window.addEventListener('load', () => {
            this.init();
        });
    }

    init() {
        let forms = document.querySelectorAll('form');
        forms.forEach((v) => {
            let submitButton = v.querySelector('[type="submit"]');
            submitButton.addEventListener('click', () => {
                if (!v.checkValidity()) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                v.classList.add('was-validated');
            });
        });
    }
}
